import { AuthLayout } from 'app_components/layouts/auth'
import React, { FC, useMemo, useState } from 'react'
import RegisterForm from './components/RegisterForm/RegisterForm'
import { IRegisterCreateUserParams, IRegisterDataForm } from 'app_types/register/registerTypes'
import RegisterPreview from './components/RegisterPreview/RegisterPreview'
import RegisterPasswordForm from './components/RegisterPasswordForm/RegisterPasswordForm'
import RegisterService from 'app_services/register/registerService'
import WaitEmailValidation from '../admin/WaitEmailValidation/WaitEmailValidation'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import RouterService from 'app_services/router/routerService'

const STEPS_AMOUNT = 3

const RegisterScreen: FC = () => {
  const background = require('app_assets/images/resources/login/background.jpg')
  const [formData, setFormData] = useState<IRegisterDataForm>()
  const [currentStep, setCurrentStep] = useState<number>(1)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [showValidateEmail, setShowValidateEmail] = useState<boolean>(false)
  const registerService = useMemo(() => new RegisterService(), [])
  const screenNotification = useMemo(() => new ScreenNotificationsUtil(), [])
  const routerService = useMemo(() => new RouterService(), [])

  const handleSubmitForm = (newFormData: IRegisterDataForm) => {
    setFormData(newFormData)
    handleChangeStep(2)
  }

  const handleSubmitPassword = async (newFormData: IRegisterDataForm) => {
    if (!formData) return
    setIsLoading(true)
    try {
      const redirect = routerService.getParamsURLObject()?.redirect
      const params: IRegisterCreateUserParams = {
        documentNumber: formData.documentNumber,
        documentType: formData.documentType,
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        password: newFormData.password,
        ...(redirect?.length ? { redirect } : {})
      }
      const response = await registerService.registerUser(params)
      if (response?.code === 200) {
        await screenNotification.showSuccessTimer({ text: 'Tu cuenta ha sido creada exitosamente.' })
        setShowValidateEmail(true)
      }
    } catch(e) {
      console.log(e)
    }
    setIsLoading(false)
  }

  const handleChangeStep = (newStep: number) => {
    if (newStep <= 0) {
      setCurrentStep(1)
    } else if (newStep > STEPS_AMOUNT) {
      setCurrentStep(STEPS_AMOUNT)
    } else {
      setCurrentStep(newStep)
    }
  }

  if (showValidateEmail) {
    return (
      <WaitEmailValidation />
    )
  }

  return (
    <AuthLayout
      background={background}
    >
      {currentStep === 1 && (
        <RegisterForm
          defaultValues={formData}
          onSubmit={handleSubmitForm}
        />
      )}
      {currentStep === 2 && (
        <RegisterPreview
          formData={formData}
          onBack={() => handleChangeStep(1)}
          onNext={() => handleChangeStep(3)}
        />
      )}
      {currentStep === 3 && (
        <RegisterPasswordForm
          onSubmit={handleSubmitPassword}
          onBack={() => handleChangeStep(2)}
          isLoading={isLoading}
        />
      )}
    </AuthLayout>
  )

}

export default RegisterScreen
